<template>
  <div class="about-menu">
    <div class="extended-block">
      <h6>What we do</h6>
      <menu-item
        path="/about/solutions"
        text="Solutions"
        caption="Learn about how our solutions can help you reach your business goals in Africa"
        @click="handleItemClick('/about/solutions')"
      />
    </div>
    <div class="extended-block">
      <h6>Company</h6>
      <menu-item
        path="/about/team"
        text="Our team"
        caption="Meet our Pan-African team of operators, investors and advisors"
        @click="handleItemClick('/about/team')"
      />
      <menu-item
        path="/about/careers"
        text="Careers"
        caption="Asoko is growing fast and has exciting opportunities in multiple locations"
        @click="handleItemClick('/about/careers')"
      />
      <menu-item
        path="/insights/developments"
        text="Press"
        caption="The latest launches and news from Asoko"
        @click="handleItemClick('/insights/developments')"
      />
    </div>
    <div class="extended-block">
      <h6>Get in touch</h6>
      <menu-item
        path="/about/contact"
        text="Contacts"
        caption="Have a question? Contact us"
        @click="handleItemClick('/about/contact')"
      />
    </div>
  </div>
</template>

<script>
import MenuItem from './menu-item'

export default {
  name: 'solutions-menu',
  components: {
    MenuItem,
  },
  methods: {
    handleItemClick(path) {
      this.$emit('hide')
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'top-menu-navigate',
        eventLabel: 'Path ' + path,
      })
      this.$gtag.event('top-menu-navigate', {
        'event_category': 'Click',
        'event_label': 'Path ' + path,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.about-menu {
  display: flex;
  flex-direction: column;
  padding: 0 $padding-l;
  @include desktop {
    min-width: 700px;
    flex-direction: row;
  }
}
.extended-block {
  padding: $padding-l $padding-m;
  h6 {
    font-size: $header-label-size;
    font-weight: 600;
    margin-bottom: $margin-m;
    text-transform: uppercase;
    color: $header-secondary-color;
  }
}
.user-block {
  padding: $padding-l $padding-m;
  background: #fffae9;
}
</style>
